<template>
    <div class="row">
        <div class="col-lg-6">
            <div class="form-group mb-2">
                <small class="input-title">Rol</small>
                <v-select v-model="data.role_id"
                    :items="roles"
                    item-text="name"
                    item-value="id"
                    hide-details
                    class="form-control form-control-sm"
                    :class="errors.role_id ? 'is-invalid' : ''">
                </v-select>
                <small class="invalid-feedback" v-for="(error, index) in errors.role_id" :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="form-group mb-2">
                <small class="input-title">Descuento: </small>
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control form-control-sm" v-model="data.discount" @keypress="DOUBLE" :class="errors.discount ? 'is-invalid' : ''" placeholder="0.00">
                    <div class="input-group-append">
                        <span class="input-group-text bg-white">
                            %
                        </span>
                    </div>
                    <small class="invalid-feedback" v-for="(error, index) in errors.discount" :key="index">{{ error }}</small>
                </div>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="form-group mb-2">
                <small class="input-title">Subscripción al boletín, noticias, ofertas, ...</small>
                <v-select v-model="data.subscribed"
                    :items="options"
                    hide-details
                    class="form-control form-control-sm"
                    :class="errors.subscribed ? 'is-invalid' : ''">
                </v-select>
                <small class="invalid-feedback" v-for="(error, index) in errors.subscribed" :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="form-group mb-2">
                <small class="input-title">Cuenta Completa</small>
                <v-select v-model="data.complete"
                    :items="options"
                    hide-details
                    class="form-control form-control-sm"
                    :class="errors.complete ? 'is-invalid' : ''">
                </v-select>
                <small class="invalid-feedback" v-for="(error, index) in errors.complete" :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="form-group mb-2">
                <small class="input-title">Permitir Crédito</small>
                <v-select v-model="data.credit"
                    :items="options"
                    hide-details
                    class="form-control form-control-sm"
                    :class="errors.credit ? 'is-invalid' : ''">
                </v-select>
                <small class="invalid-feedback" v-for="(error, index) in errors.credit" :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="form-group mb-2">
                <small class="input-title">Pin: </small>
                <input type="text" class="form-control form-control-sm" v-model="data.pin" @keypress="NUMBER" :class="errors.pin ? 'is-invalid' : ''" placeholder="0000">
                <small class="invalid-feedback" v-for="(error, index) in errors.pin" :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="form-group mb-2">
                <small class="input-title">Última fecha de exoneración: </small>
                <v-menu v-model="menu_last_exemption"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field 
                            :value="data.last_exemption_at" 
                            v-bind="attrs" 
                            v-on="on" 
                            hide-details
                            readonly 
                            clearable
                            :placeholder="'0000-00-00'"
                            class="form-control form-control-sm" 
                            @click:clear="data.last_exemption_at = ''"
                            :class="errors.last_exemption_at ? 'is-invalid' : ''">
                        </v-text-field>
                    </template>
                    <v-date-picker 
                        v-model="data.last_exemption_at" 
                        no-title 
                        scrollable
                        @input="menu_last_exemption = false">
                    </v-date-picker>
                </v-menu>
                <small class="invalid-feedback" v-for="(error, index) in errors.last_exemption_at" :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="form-group mb-2">
                <small class="input-title">Precio por libra: </small>
                <input type="text" class="form-control form-control-sm" v-model="data.price_per_pound" @keypress="DOUBLE" :class="errors.price_per_pound ? 'is-invalid' : ''" placeholder="0">
                <small class="invalid-feedback" v-for="(error, index) in errors.price_per_pound" :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-lg-6" v-if="data.price_per_pound > 0">
            <div class="form-group mb-2">
                <small class="input-title">Monto minimo facturable: </small>
                <input type="text" class="form-control form-control-sm" v-model="data.minimum_billable_amount" @keypress="DOUBLE" :class="errors.minimum_billable_amount ? 'is-invalid' : ''" placeholder="0">
                <small class="invalid-feedback" v-for="(error, index) in errors.minimum_billable_amount" :key="index">{{ error }}</small>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['data', 'errors'],
    data(){
        return{
            menu_last_exemption: false,
            account_types: [
                { value: 0, text: 'Sistema' },
                { value: 1, text: 'Personal' },
                { value: 2, text: 'Empresarial' },
                { value: 3, text: 'Envíos familiares' }
            ],
            options: [
                { value: 0, text: 'No' },
                { value: 1, text: 'Si' }
            ],
            roles: [],
        }
    },
    created(){
        this.ROLES()
    },
    methods: {
        ROLES: function(){
            let vue = this
            axios({url: 'roles', method: 'GET' })
            .then((resp) => {
                vue.roles = resp.data
            })
        },
    }
}
</script>